export default __webpack_public_path__ + "static/dd-reno-3c77ce0bf4a8a5e90268f475d1b20c42.jpg";